import { TCreateConverter, TFetchConverter } from 'data/types/convertor.types';
import {
  TGetLeasePacketAccess,
  TGetLeasePacketAccessUI,
  TLeasePacketDB,
  TLeasePacketUI,
  TValidateLeasePacketCode,
  TValidateLeasePacketCodeUI,
} from 'data/types/leasePacket.types';

export const leasePacketAccessConvertor: TCreateConverter<
  TGetLeasePacketAccess,
  TGetLeasePacketAccessUI
> = {
  toDb: data => ({
    code: data.code?.toUpperCase() || '',
  }),
};

export const validateLeasePacketCodeConvertor: TCreateConverter<
  TValidateLeasePacketCode,
  TValidateLeasePacketCodeUI
> = {
  toDb: data => ({
    code: data.code?.toUpperCase() || '',
  }),
};

export const leasePacketDataConverter: TFetchConverter<
  TLeasePacketUI,
  TLeasePacketDB
> = {
  fromDb: data => {
    return {
      generatedDocUrl: data.generatedDocUrl,
      policyId: data.policyId,
      accessCodeId: data.accessCodeId,
      propertyManagementName: data.propertyManagementName,
      propertyManagementLogo: data.propertyManagementLogo,
      propertyManagerName: data.propertyManagerName,
      propertyManagementId: data.propertyManagementId,
      shouldTenantSignAddendum: data?.shouldTenantSignAddendum,
    };
  },
};
